import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "../components/Layout";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-8 py-16 md:py-24">
        <div className="max-w-md mx-auto text-center glass-card p-12">
          <h1 className="text-4xl font-bold mb-6 text-gray-900">404</h1>
          <p className="text-xl text-gray-600 mb-8">Ups! Iskana stran ne obstaja.</p>
          <Button asChild className="bg-medical-500 hover:bg-medical-600 text-white rounded-full">
            <Link to="/">Nazaj na domačo stran</Link>
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;